export default "__VITE_ASSET__b99f146f__"